import React, { useEffect, useState } from 'react';
import { default as ReactSelect, components } from "react-select";
import CreatableSelect from 'react-select/creatable';
import ToggleSwitch from '../../../Components/ToggleSwitch';
import { NetworkManager } from '../../../Components/NetworkManager';

import { CustomMultiValue, CustomOption } from '../../../Components/SelectCustomComponents';

const TyreFields = ({
    toggles,
    handleToggleChange,
    requiredTyreFields,
    handleRequiredChange,
    selectedTyreBrands,
    handleMultiSelectAll,
    tyreBrand,
    selectedTyreSizes,
    tyreSize,
    selectedTyreDepth,
    tyreDepth,
    tyreCondition,
    setTyreCondition,
    tyreStatus,
    setTyreStatus,
    isValid
}: any) => {
    return (
        <>
            <div className='mt-3' style={{ border: "1px solid #e0e0e0", borderRadius: "5px", padding: "10px" }}>
                <div className={`row`} style={{ height: "12px" }}>{isValid ? <span /> : <small className="text-danger fw-700" >Note: Please select at least one option.</small>}</div>
                <div className={`row g-3 align-item-center mt-0`} style={{ position: "relative" }} >
                    <div className="col-md-4">
                        <div className='d-flex justify-content-between pe-2'>
                            <ToggleSwitch
                                label="Select Tire Brand"
                                labelStyle="ms-2 fw-600"
                                checked={toggles.enableTyreBrands}
                                onChange={(value: any) => { handleToggleChange("enableTyreBrands", value) }} />
                            <div className="d-flex justify-content-center align-items-end">
                                <input type="checkbox" role="button" className='mb-2' checked={requiredTyreFields.tyreBrandRequired}
                                    onChange={(e) => handleRequiredChange("tyreBrandRequired", e.target.checked)} disabled={!toggles.enableTyreBrands} />
                                <label className='ms-1' htmlFor="Mandatory" style={{ display: "inline", fontWeight: "normal", marginBottom: "5px" }}>Mandatory</label>
                            </div>
                        </div>
                        <div className={`col-md-12`}>
                            <ReactSelect
                                name="tyreBrands"
                                placeholder={"Select Tire Brand"}
                                isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                                options={[{ label: "All", value: 0 }, ...tyreBrand]}
                                value={selectedTyreBrands}
                                onChange={(selected: any) => handleMultiSelectAll(selected, "brand")}
                                isDisabled={!toggles.enableTyreBrands}
                            />
                            {toggles.enableTyreBrands && <a className="ms-1 align-self-center" title="Type: Searchable Dropdown, one or more options can be selected">
                                <img className=" pe-auto" 
                                src={ "./../images/info.svg"} alt="info" width={13} height={13}/>
                            </a>}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className='d-flex justify-content-between pe-2'>
                            <ToggleSwitch
                                label="Select Tire Sizes"
                                labelStyle="ms-2 fw-600"
                                checked={toggles.enableTyreSizes}
                                onChange={(value: any) => { handleToggleChange("enableTyreSizes", value) }}
                            />
                            <div className="d-flex justify-content-center align-items-end">
                                <input type="checkbox" role="button" className='mb-2' checked={requiredTyreFields.tyreSizeRequired}
                                    onChange={(e) => handleRequiredChange("tyreSizeRequired", e.target.checked)} disabled={!toggles.enableTyreSizes} />
                                <label className='ms-1' htmlFor="Mandatory" style={{ display: "inline", fontWeight: "normal", marginBottom: "5px" }}>Mandatory</label>
                            </div>
                        </div>
                        <div className={`col-md-12`}>
                            <ReactSelect
                                placeholder="Select Tire Sizes"
                                name="tyreSizes"
                                isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                                options={[{ label: "All", value: 0 }, ...tyreSize]}
                                value={selectedTyreSizes}
                                onChange={(selected: any) => handleMultiSelectAll(selected, "size")}
                                isDisabled={!toggles.enableTyreSizes}
                            />
                            {toggles.enableTyreSizes && <a className="ms-1 align-self-center" title="Type: Searchable Dropdown, one or more options can be selected">
                                <img className=" pe-auto" 
                                src={ "./../images/info.svg"} alt="info" width={13} height={13}/>
                            </a>}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className='d-flex justify-content-between pe-2'>
                            <ToggleSwitch
                                label="Select Tire Depth"
                                // labelStyle="ms-2 fw-600"
                                checked={toggles.enableTyreDepth}
                                onChange={(value: any) => { handleToggleChange("enableTyreDepth", value) }} />
                            <div className="d-flex justify-content-center align-items-end">
                                <input type="checkbox" role="button" className='mb-2' checked={requiredTyreFields.tyreDepthRequired}
                                    onChange={(e) => handleRequiredChange("tyreDepthRequired", e.target.checked)} disabled={!toggles.enableTyreDepth} />
                                <label className='ms-1' htmlFor="Mandatory" style={{ display: "inline", fontWeight: "normal", marginBottom: "5px" }}>Mandatory</label>
                            </div>
                        </div>
                        <div className={`col-md-12`}>
                            <ReactSelect
                                placeholder="Select Tire Depth"
                                name="tyreDepth"
                                isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                components={{ MultiValue: CustomMultiValue, Option: CustomOption }}
                                options={[{ label: "All", value: 0 }, ...tyreDepth]}
                                value={selectedTyreDepth}
                                onChange={(selected: any) => handleMultiSelectAll(selected, "depth")}
                                isDisabled={!toggles.enableTyreDepth}
                            />
                            {toggles.enableTyreDepth && <a className="ms-1 align-self-center" title="Type: Searchable Dropdown, one or more options can be selected">
                                <img className=" pe-auto" 
                                src={ "./../images/info.svg"} alt="info" width={13} height={13}/>
                            </a>}
                        </div>
                    </div>
                </div>
                <div className={`row g-3 align-item-center mt-0 mb-1`} style={{ position: "relative" }} >
                    <div className="col-md-6">
                        <div className='d-flex justify-content-between pe-2'>
                            <ToggleSwitch
                                label="Select Tire Condition"
                                labelStyle="ms-2 fw-600"
                                checked={toggles.enableTyreCondition}
                                onChange={(value: any) => { handleToggleChange("enableTyreCondition", value) }} />
                            <div className="d-flex justify-content-center align-items-end">
                                <input type="checkbox" role="button" className='mb-2' checked={requiredTyreFields.tyreConditionRequired}
                                    onChange={(e) => handleRequiredChange("tyreConditionRequired", e.target.checked)} disabled={!toggles.enableTyreCondition} />
                                <label className='ms-1' htmlFor="Mandatory" style={{ display: "inline", fontWeight: "normal", marginBottom: "5px" }}>Mandatory</label>
                            </div>
                        </div>
                        <div className={`col-md-12`}>
                            <CreatableSelect
                                isMulti
                                options={[]}
                                name="tyreCondition"
                                value={tyreCondition}
                                onChange={(selected:any) => setTyreCondition(selected)}
                                placeholder={"Enter tyre condition..."}
                                className="basic-multi-select "
                                classNamePrefix="select"
                                isDisabled={!toggles.enableTyreCondition}
                                styles={{
                                    control: (provided: any) => ({
                                        ...provided,
                                        minHeight: '42px',
                                    }),
                                }}
                            />
                            {toggles.enableTyreCondition && <a className="ms-1 align-self-center" title="Type: Creatable Field, One or more new options can be created by typing text and pressing enter">
                                <img className=" pe-auto" 
                                src={ "./../images/info.svg"} alt="info" width={13} height={13}/>
                            </a>}
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className='d-flex justify-content-between pe-2'>
                            <ToggleSwitch
                                label="Select Tire Status"
                                labelStyle="ms-2 fw-600"
                                checked={toggles.selectTyreStatus}
                                onChange={(value: any) => { handleToggleChange("selectTyreStatus", value) }} />
                            <div className="d-flex justify-content-center align-items-end">
                                <input type="checkbox" role="button" className='mb-2' disabled={!toggles.selectTyreStatus}
                                    checked={requiredTyreFields.tyreStatusRequired} onChange={(e) => handleRequiredChange("tyreStatusRequired", e.target.checked)} />
                                <label className='ms-1' htmlFor="Mandatory" style={{ display: "inline", fontWeight: "normal", marginBottom: "5px" }}>Mandatory</label>
                            </div>
                        </div>
                        <div className={`col-md-12`}>
                            <CreatableSelect
                                isMulti
                                options={[]}
                                name="tyreStatus"
                                value={tyreStatus}
                                onChange={(selected:any) => setTyreStatus(selected)}
                                placeholder={"Enter tyre status..."}
                                className="basic-multi-select "
                                classNamePrefix="select"
                                isDisabled={!toggles.selectTyreStatus}
                                styles={{
                                    control: (provided: any) => ({
                                        ...provided,
                                        minHeight: '42px',
                                    }),
                                }}
                            />
                            {toggles.selectTyreStatus && <a className="ms-1 align-self-center" title="Type: Creatable Field, One or more new options can be created by typing text and pressing enter">
                                <img className=" pe-auto" 
                                src={ "./../images/info.svg"} alt="info" width={13} height={13}/>
                            </a>}
                        </div>
                    </div>
                </div>
            </div>
            <div className='row mt-3 d-none'>
                <div className="d-flex">
                    <ToggleSwitch
                        label="Repeat steps for all Tires of the Equipment"
                        checked={toggles.repeatForAllTires}
                        onChange={(value: any) => handleToggleChange("repeatForAllTires", value)} />
                    <a className="ms-1 align-self-center">
                        <img
                            className=" pe-auto"
                            src={"./../images/info.svg"} alt="info" width={18} height={18}
                            title="The number of tires will be shown based on the axles configured for the equipment" />
                    </a>
                </div>
            </div>
        </>
    );
};

export default TyreFields;
